module.exports = __webpack_public_path__ + "img/goodsB1.970c0d62.png";